import { generatePath } from 'react-router-dom'
import { REQUEST_STATUS } from '@/constants/request-status'
import { REQUEST_TYPE } from '@/constants/request-type'
import { ROUTES } from '@/constants/routes'
import type { Request } from '@/types/requests/request'

export function getUrlRedirectByRequest(request: Request) {
  if (request) {
    let url = ''

    switch (request.requestType.id) {
      case REQUEST_TYPE.EXTERNAL_TRANSFER.id:
        if (request.requestStatus.id === REQUEST_STATUS.NOT_STARTED.id) {
          url = ROUTES.REQUEST_TYPES_EXTERNAL_TRANSFER.route
        } else {
          url = ROUTES.REVIEW_TYPES_EXTERNAL_TRANSFER.route
        }
        break
      case REQUEST_TYPE.CHANGE_OF_MAJOR.id:
        if (request.requestStatus.id === REQUEST_STATUS.NOT_STARTED.id) {
          url = ROUTES.REQUEST_TYPES_CHANGE_OF_MAJOR.route
        } else {
          url = ROUTES.REVIEW_TYPES_CHANGE_OF_MAJOR.route
        }
        break
      case REQUEST_TYPE.CREDIT_TRANSFER.id:
        if (request.requestStatus.id === REQUEST_STATUS.NOT_STARTED.id) {
          url = ROUTES.REQUEST_TYPES_CREDIT_TRANSFER.route
        } else {
          url = ROUTES.REVIEW_TYPES_CREDIT_TRANSFER.route
        }
        break
    }

    return generatePath(`/${url}`, { id: request.id })
  }
}
